import { render, staticRenderFns } from "./TwoFactorChallange.vue?vue&type=template&id=0a78f4ff&"
import script from "./TwoFactorChallange.vue?vue&type=script&lang=js&"
export * from "./TwoFactorChallange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports